import { memo } from 'react';
import { useTheme } from 'styled-components';

import { TableCell, TableRow } from '../../tanstack-table.styles';
import { Skeleton } from './skeleton-row.styles';
import { SkeletonRowProps } from './skeleton-row.types';

export const SkeletonRowComponent = ({ columnCount, cellPadding }: SkeletonRowProps) => {
	const { isDark } = useTheme();

	return (
		<TableRow>
			{Array.from({ length: columnCount }).map((_, index) => (
				<TableCell key={`skeleton-row-${index}`} cellPadding={cellPadding}>
					<Skeleton isDark={isDark} />
				</TableCell>
			))}
		</TableRow>
	);
};

export default memo(SkeletonRowComponent);
